import { graphql } from 'gatsby';
import React from 'react';
import { css } from '@emotion/react';
import { colors } from '../../primitives/colors';
import Container from '../../primitives/grid/container';
import paddingDefault from '../../utils/padding-default';
import { breakpoints } from '../../primitives/tokens';

const styles = {
    background: css({
        backgroundColor: colors.grey100,
    }),
    author: css({
        marginBottom: '4px',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '1.6px',
    }),
    company: css({
        marginBottom: '12px',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 300,
        letterSpacing: '1.6px',
    }),
    quote: css({
        color: colors.primaryOrange,
        lineHeight: 1.375,
        fontSize: '32px',

        [breakpoints.tb]: {
            fontSize: '26px',

        },
    }),
    testimonialOuterWrap: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        [breakpoints.tb]: {
            flexDirection: 'column',
        },
    }),
    testimonialInnerWrap: css({
        paddingTop: '16px',
        paddingLeft: '28px',
        marginBottom: '0',
        marginRight: '80px',
        width: '66.666667%',

        [breakpoints.tb]: {
            paddingTop: '0',
            paddingLeft: '0',
            marginRight: '0',
            width: 'unset',
            marginBottom: '32px',

        },
    }),
};

const Testimonial: React.FC<Queries.TestimonialDataFragment> = (data) => {
    const { authorName, authorCompany, quote } = data;

    return (
        <div css={[paddingDefault(), styles.background]}>
            <Container>
                <div css={styles.testimonialOuterWrap}>
                    <div css={styles.testimonialInnerWrap}>
                        <p css={styles.author}>{authorName}</p>
                        <p css={styles.company}>{authorCompany}</p>
                        <p css={styles.quote}>{quote}</p>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export const query = graphql`
  fragment TestimonialData on CsTestimonial {
    ... on CsTestimonial {
      authorName
      authorCompany
      quote
    }
  }
`;

export default Testimonial;
